
/**
 * meta title・descriptionを設定する関数
 * Vue-Routerを使って表示させるコンポーネントで使う
 *
 * @param title titleに設定する文言
 * @param description descriptionに設定する文言
 */
export function setTitleAndDescription(title, description) {
    document.title = title;
    if(description) {
        document.querySelector("meta[name='description']").setAttribute('content', description)
    }
}
